import type { RoleCounts } from '@onuw/roles-data'

/** A deck the decks guide recommends for a table of that many players (content.test.ts checks each is valid). */
export const DECKS_BY_PLAYERS: { players: number; note: string; roles: RoleCounts }[] = [
  {
    players: 3,
    note: 'The classic deck. Quick and brutal: three of the six cards lie in the center.',
    roles: { werewolf: 2, seer: 1, robber: 1, troublemaker: 1, villager: 1 },
  },
  {
    players: 4,
    note: 'The Drunk and the Insomniac join: one more card on the move, and one player who sees how the night ended.',
    roles: { werewolf: 2, seer: 1, robber: 1, troublemaker: 1, drunk: 1, insomniac: 1 },
  },
  {
    players: 5,
    note: 'Add the Tanner. From here on, the player who looks guilty may want to.',
    roles: { werewolf: 2, seer: 1, robber: 1, troublemaker: 1, drunk: 1, insomniac: 1, tanner: 1 },
  },
  {
    players: 6,
    note: 'Add the Minion, who knows the wolves and will take the vote for them.',
    roles: { werewolf: 2, minion: 1, seer: 1, robber: 1, troublemaker: 1, drunk: 1, insomniac: 1, tanner: 1 },
  },
  {
    players: 7,
    note: 'The Masons replace the Tanner: two players who can vouch for each other steady a bigger table.',
    roles: { werewolf: 2, minion: 1, mason: 2, seer: 1, robber: 1, troublemaker: 1, drunk: 1, insomniac: 1 },
  },
  {
    players: 8,
    note: 'Add the Hunter, whose vote still counts after the table turns on him.',
    roles: {
      werewolf: 2,
      minion: 1,
      mason: 2,
      seer: 1,
      robber: 1,
      troublemaker: 1,
      drunk: 1,
      insomniac: 1,
      hunter: 1,
    },
  },
  {
    players: 9,
    note: 'The Tanner returns. Nine players can afford one who plays for himself.',
    roles: {
      werewolf: 2,
      minion: 1,
      mason: 2,
      seer: 1,
      robber: 1,
      troublemaker: 1,
      drunk: 1,
      insomniac: 1,
      hunter: 1,
      tanner: 1,
    },
  },
  {
    players: 10,
    note: 'Every card of the base game but the Doppelgänger, with a single Villager.',
    roles: {
      werewolf: 2,
      minion: 1,
      mason: 2,
      seer: 1,
      robber: 1,
      troublemaker: 1,
      drunk: 1,
      insomniac: 1,
      villager: 1,
      hunter: 1,
      tanner: 1,
    },
  },
  {
    players: 11,
    note: 'A third wolf, the Mystic Wolf, and the Apprentice Seer to balance him.',
    roles: {
      werewolf: 2,
      mysticWolf: 1,
      minion: 1,
      mason: 2,
      seer: 1,
      appSeer: 1,
      robber: 1,
      troublemaker: 1,
      drunk: 1,
      insomniac: 1,
      hunter: 1,
      tanner: 1,
    },
  },
  {
    players: 12,
    note: 'A full table. The Witch adds one more card that changes hands.',
    roles: {
      werewolf: 2,
      mysticWolf: 1,
      minion: 1,
      mason: 2,
      seer: 1,
      appSeer: 1,
      robber: 1,
      witch: 1,
      troublemaker: 1,
      drunk: 1,
      insomniac: 1,
      hunter: 1,
      tanner: 1,
    },
  },
]
